import { COMBO_STEPS, type ComboColor } from './config';

export class ComboTracker {
  color: ComboColor = 'none';
  streak = 0;
  multiplier = 1;
  timer = 0;
  window = 3.2;
  fever = false;

  reset(): void {
    this.color = 'none';
    this.streak = 0;
    this.multiplier = 1;
    this.timer = 0;
    this.fever = false;
    this.window = 3.2;
  }

  enableFever(): void {
    this.fever = true;
    this.window = 5.5;
    this.multiplier = Math.min(2, this.multiplier + .35);
  }

  onGrab(combo: ComboColor): { broke: boolean; multiplier: number } {
    if (combo === 'none') {
      const broke = this.streak > 0;
      this.reset();
      this.fever = false;
      this.window = 3.2;
      return { broke, multiplier: 1 };
    }

    if (this.color === combo) {
      this.streak += 1;
    } else {
      this.color = combo;
      this.streak = 1;
    }

    const idx = Math.min(COMBO_STEPS.length - 1, this.streak - 1);
    this.multiplier = COMBO_STEPS[idx];
    if (this.fever) this.multiplier = Math.min(2, this.multiplier + .35);
    this.timer = this.window;
    return { broke: false, multiplier: this.multiplier };
  }

  update(dt: number): void {
    if (this.timer > 0) {
      this.timer -= dt;
      if (this.timer <= 0) {
        this.streak = 0;
        this.color = 'none';
        this.multiplier = 1;
        this.timer = 0;
      }
    }
  }

  get label(): string {
    if (this.streak <= 1) return '';
    return `连击 ×${this.multiplier}`;
  }
}
